import { useI18n } from '../../i18n/I18nContext';

function Feature({title, description}) {
    const { t } = useI18n();

    return [
        <h3 className="text-base font-bold text-dark">- {title}{t("common.colon")}</h3>,
        <div className="text-base text-dark" dangerouslySetInnerHTML={{__html: description}}></div>
    ];
}

function Features({title, features, lastSection}) {
    const { t } = useI18n();
    const rowsPerColumn = Math.ceil(features.length / 2);
    
    const firstFeatures = features.slice(0, rowsPerColumn);
    const secondFeatures = features.slice(rowsPerColumn);

    const column = (features) => (<div data-reveal className="flex flex-col flex-1">
      {features.map((feature, index) => [
        index > 0 && <br />,
        <Feature title={feature.title} description={feature.description} />
      ])}
      </div>
    );

    return (
        <section id="fonctionnalites" className={"relative overflow-x-clip pt-[3.75rem] px-10" + (lastSection ? " pb-[5rem]" : "")}>
            <div className="flex flex-col relative max-w-[1200px] mx-auto">
                <h2 data-reveal className="text-base font-bold text-dark uppercase">{t("projects.common.includes", undefined, { title })}</h2>
                <br />
                <div className="flex flex-col items-center gap-x-12 lg:items-start lg:flex-row">
                    { column(firstFeatures) }
                    { secondFeatures.length > 0 && [
                        <br className="lg:hidden" />,
                        column(secondFeatures)
                    ]}
                </div>
            </div>
        </section>
    );
}

export default Features;
